import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

import MyApps from '../../core/MyApps';

const OverWriteMyApps = styled(MyApps)`
  display: none;
  overflow-y: auto;
  padding-bottom: 2rem;
  position: fixed;
  z-index: 31;
  top: 0;

  ${props =>
    props.show &&
    css`
      display: block;
    `};

  ${mediaqueries.greaterThan('mobile')`
    overflow-y: hidden;
    overflow-x: hidden;
    padding-bottom: 0;

    &:before {
      background-color: ${props => props.theme.colors.dark};
      content: '';
      height: 100%;
      left: 0;
      opacity: 0.7;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: -1;
    }  
  `};

  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('520px')};
    &:before {
      content: none;
    }
  `};
  ${mediaqueries.between('greatherDesktop', 'lessDesktop')`
    width: ${rem('520px')};
    &:before {
      content: none;
    }
  `};
`;

export default OverWriteMyApps;
